<template>
  <div>
    <div class="row">
      <div class="col-md-4 text-left">
        <p class="title">{{ headers["client"] }}</p>
        <p>{{ headers["comp_address"] }}</p>
        <p>{{ headers["comp_contact"] }}</p>
        <p> {{ headers["On farm rep"] }}</p>
      </div>
      <div class="col-md-4 col-md-offset-4 text-right">
        <p class="title">Drug Chart for {{ headers["Season"] }} Season</p>
        <p>Owner/Farm: {{ headers["client"] }}</p>
        <p>{{ headers["Shed Address"] }}</p>
      </div>
    </div>

    <br>

    <div class="row">
      <table class="table">
        <thead>
          <tr>
            <th width="12%">Drug Name</th>
            <th width="14%">Drug Use</th>
            <th width="15%">Dose Rate / Interval</th>
            <th width="14%">Route</th>
            <th width="14%">Milk WHP (from last treatment)</th>
            <th width="9%">Meat WHP (from last treatment)</th>
            <th width="20%">Comments</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(groupDrugs, groupName, groupIndex) in groups">
            <tr class="group-name" :key="groupIndex+'_first_table_row'">
              <td>{{ groupName }}</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr v-for="(drug, drugIndex) in groupDrugs" :key="groupIndex+groupName+drugIndex">
              <td>{{ drug["Drug Name"] }}</td>
              <td><b>{{ drug["Use For"] }}</b></td>
              <td>{{ drug["Dose rate / Interval"] }}</td>
              <td>{{ drug["Route"] }}</td>
              <td>{{ drug["WHP Milk"] }}</td>
              <td>{{ drug["WHP Meat"] }}</td>
              <td>{{ drug["Comments"] }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'headers',
    'groups',
  ],
};
</script>

<style scoped>
span.blocked {
  display: block;
}
tr.group-name {
  background-color: rgb(54, 173, 122);
  font-size: 1.15em;
  font-weight: bold;
}
td {
  text-align: left;
  padding: 4px !important;
}
th {
  font-weight: normal;
}
p.title {
  font-size: 20px;
}
</style>
